import React from 'react';
import { Link } from 'react-router-dom';
import BanffLastDay from '../images/BanffLastDay.jpg';
import symbol from '../images/symbol.jpg';

const backgroundImageStyle = {
  height: 'calc(50vh - 70px)',
  backgroundImage: `url(${BanffLastDay})`,
  backgroundSize: "100% 100%"
};

const imgStyle = {
  width: "40%",
  height: "40%"
};

const Header = () => {
  return (
    <Link>
      <Link className="ui secondary pointing menu">
        <Link to="/" className="item">
          <img src={symbol} style={imgStyle} alt="symbol" />
        </Link>
        <Link className="right menu">
          <Link to="/Contact" className="item">
            Contact
          </Link>
        </Link>
        <div className="menu">
          <Link to="/Poster" className="item">
            Poster
          </Link>
        </div>
        <div className="menu">
          <Link to="/DrAnetaLazarov" className="item">
            About Aneta
          </Link>
        </div>
        <div className="menu">
          <Link to="/NetaKaminsky" className="item">
            About Neta
          </Link>
        </div>
        <Link className="menu">
          <Link to="/" className="item">
            Home
          </Link>
        </Link>
      </Link>
      <div style={backgroundImageStyle}/>
    </Link>
  );
};

export default Header;